/* -------------------------------------------------------------------------------------------------
 * IMicrosoftSSOModel
 * -----------------------------------------------------------------------------------------------*/

export interface IMicrosoftSSOModel {
    _id: string;
    client: string;
    user: string;
    createdAt: string;
}

/* -------------------------------------------------------------------------------------------------
 * MicrosoftSSOModel
 * -----------------------------------------------------------------------------------------------*/
export class MicrosoftSSOModel {
    _id: string;
    client: string;
    user: string;
    createdAt: string;

    constructor(data: Partial<IMicrosoftSSOModel>) {
        this._id = data._id ?? '';
        this.client = data.client ?? '';
        this.user = data.user ?? '';
        this.createdAt = data.createdAt ?? '';
    }

    static fromObject(data: Partial<IMicrosoftSSOModel>): MicrosoftSSOModel {
        const model = new MicrosoftSSOModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IMicrosoftSSOModel>[]): MicrosoftSSOModel[] {
        return data.map((row) => MicrosoftSSOModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IMicrosoftSSOModel>): MicrosoftSSOModel {
        const model = new MicrosoftSSOModel(data);

        return model;
    }

    toObject(): IMicrosoftSSOModel {
        const data: IMicrosoftSSOModel = {
            _id: this._id,
            client: this.client,
            user: this.user,
            createdAt: this.createdAt,
        };

        return data;
    }
}
